import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
import { jsx as t } from "react/jsx-runtime";
import { forwardRef as n } from "react";
//#region src/components/inputs/inputs.css.ts
var r = "_44xa00", i = "_44xa01 _44xa00", a = "_44xa02 _44xa00", o = n(({ className: n, ...i }, a) => /* @__PURE__ */ t("input", {
	...i,
	className: e(r, n),
	ref: a
}));
o.displayName = "TextInput";
var s = n(({ className: n, ...r }, a) => /* @__PURE__ */ t("textarea", {
	...r,
	className: e(i, n),
	ref: a
}));
s.displayName = "TextArea";
var c = n(({ className: n, ...r }, i) => /* @__PURE__ */ t("select", {
	...r,
	className: e(a, n),
	ref: i
}));
c.displayName = "SelectInput";
//#endregion
export { c as SelectInput, s as TextArea, o as TextInput };

//# sourceMappingURL=inputs.js.map